import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from "recharts";
import { GetLightpointData } from "../hooks/middleware.js";
import { CountItems, SortItems, GetTopItems, CountTotal } from "../hooks/chartMethods.js";

export default function TileTopManufacturers({ id }) {
  const { data, error } = GetLightpointData(id);
  const counts = CountItems(data, "locationstreet");
  const sorted = SortItems(counts, "count");

  const finalData = GetTopItems(sorted, 10, "Others");
  const totalCount = CountTotal(finalData, "count");

  if (error) return <p>Error loading data.</p>;
  if (!finalData) return <p>Loading Bar Chart...</p>;
  if (finalData.length === 0) return <p>No data found</p>;

  return (
    <div>
      <div style={{ display: "flex", gap: "1rem" }}>
        <div style={{ minWidth: "200px" }}>
          {finalData.map(item => (
            <div key={item.name} className="table-row" style={{display: "flex", alignItems: "center", height: "37.5px", marginBottom: "4px",}}>
              <span style={{ minWidth: "150px" }}>{item.name}</span>
              <span style={{ minWidth: "80px", textAlign: "right" }}>{item.count}</span>
              <span style={{ minWidth: "80px", textAlign: "right" }}>
                {((item.count / totalCount) * 100).toFixed(1)}%
              </span>
            </div>
          ))}
        </div>

        <div style={{ flex: 1, height: finalData.length * 40 + 50 }}>
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              data={finalData}
              layout="vertical"
              margin={{ top: 0, right: 0, left: 0, bottom: 0 }}
              barCategoryGap="30%"
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis type="number" allowDecimals={false} />
              <YAxis type="category" dataKey="name" width={0} />
              <Tooltip
                formatter={(value, name, props) => [`${props.payload.name}: ${value}`, ""]}
                labelFormatter={() => ""}
              />
              <Bar dataKey="count" fill="#f76e24" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}
